import { ChangeDetectionStrategy, Component, Input, output, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { SecondsInDaysPipe } from '@core/time-legacy';
import type { IconToken } from '@core/user-interface-legacy';
import { DropdownItemComponent, IconComponent, RtTooltip } from '@core/user-interface-legacy';
import { WorkflowAutomation } from '@core/workflow-automations-types';

@Component({
  selector: 'rt-stage-item',
  templateUrl: './stage-item.component.html',
  styleUrls: ['./stage-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DropdownItemComponent, IconComponent, RtTooltip, SecondsInDaysPipe, TranslatePipe],
})
export class StageItemComponent {
  public readonly title = input<string>(undefined!);
  public readonly clickable = input(true);
  public readonly disabled = input(false);
  public readonly hasAutomatedActions = input<boolean>(undefined!);
  public readonly unbiasedHiringEnabled = input<boolean>(undefined!);
  public readonly isCurrent = input<boolean>(false);
  public readonly showHiredIcon = input<boolean>(false);
  public readonly tooltipCopy = input<string>();
  public readonly automations = input<WorkflowAutomation[]>();
  @Input() public description?: string;
  @Input() public timeLimit: number | null;

  public showDetailsClick = output<void>();
  public stageClick = output<void>();
  public checkedIconToken: IconToken;
  public actionIconToken: IconToken;

  public ngOnChanges() {
    this.setIconTokens();
  }

  public setIconTokens() {
    this.checkedIconToken = !this.disabled()
      ? this.isCurrent()
        ? 'colorIconPrimaryDefault'
        : 'colorIconDefault'
      : 'colorIconDisabled';
    this.actionIconToken = !this.disabled() ? 'colorIconDefault' : 'colorIconDisabled';
  }
}
